import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://gnbgxnmdttdvgiwluoxy.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImduYmd4bm1kdHRkdmdpd2x1b3h5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYyODE1NTksImV4cCI6MjA5MTg1NzU1OX0.tmMO_uJOsYJWaJG4OxbLSk47O2NdQeCZvyVqE7_BxLc";

export const supabase = createClient(supabaseUrl, supabaseKey);